<div class="headerdiv">
    <div >
      <h3 class="pagetitle">Email Shots</h3>
      <label class="settings"><a>Settings</a> | <a>Analytics</a> </label>
    </div>
  
  </div>

<form [formGroup]='Email'>

 
  <mat-card>
    <input formControlName='subject' class="subject" placeholder="Subject">

    <!-- https://www.npmjs.com/package/ngx-quill -->
    <quill-editor formControlName='body' [styles]="{height: '250px'}"></quill-editor>
    <button (click)="openModal(template)" mat-button class="sendbutton" color="primary">Send Email</button>
    <ng-template #template>
      <div class="modal-body text-center">
        <h6>Are you sure you want to send this email</h6>
        <p>By clicking confirm this email will be sent to all users registered and have their newsletter turned on</p>
        <button type="button" class="btn btn-default" (click)="cancel()" >Cancel</button>
        <button type="button" class="btn confirm" (click)="sendEmail()">Confirm</button>
      </div>
    </ng-template>
  </mat-card>

</form>





  <h4>Previous Emails</h4>
  <mat-list class="list" role="list">
    <mat-list-item role="listitem">
      <label class="listsubject">Subject</label>
      <label class="listdate">Date</label>
      <label class="listview">View Email</label>
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item role="listitem" *ngFor="let item of previousEmails">
      <label class="listsubject">{{item.subject}}</label>
      <label class="listdate">{{item.created_at | date: 'MMM dd,yyyy HH:mm'}}</label>
      <button type="button" class="btn confirm" (click)="viewEmail(item.subject, item.body)">View Email</button>
    </mat-list-item>
  </mat-list>
  
  
